import axios from "axios";
import { API_BASE } from "../../config/env";

export const FETCH_UPDATEAPPLICATIONSTATUS_FULFILLED = "FETCH_UPDATEAPPLICATIONSTATUS_FULFILLED";
export const FETCH_UPDATEAPPLICATIONSTATUS_REJECTED = "FETCH_UPDATEAPPLICATIONSTATUS_REJECTED";
export const FETCH_UPDATEAPPLICATIONSTATUS_PENDING = "FETCH_UPDATEAPPLICATIONSTATUS_PENDING";
export const RESET_UPDATEAPPLICATIONSTATUS = "RESET_UPDATEAPPLICATIONSTATUS";




export function updateApplicationStatus(ApplicationId, ApplicationStatus) {

    const token = localStorage.getItem("accessToken")
    return (dispatch) => {
        dispatch({
            type: "FETCH_UPDATEAPPLICATIONSTATUS",
            payload: axios({
                method: "post",
                url: `${API_BASE}/api/v2/second-opinion/status/${ApplicationId}/${ApplicationStatus}`,
                data: {},
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning": "69920"
                },
            }).then((result) => result.data),
        });
    };
}


export function resetUpdateApplicationStatus() {
    return (dispatch) => {
        dispatch({
            type: "RESET_UPDATEAPPLICATIONSTATUS",
        });
    };
}